<template>
    <v-footer padless app style="z-index:100;">
        <v-row justify="center" no-gutters>
            <v-spacer></v-spacer>
            <v-btn
              v-for="(item, idx) in items"
              :key="idx"
              :href="item.link"
              target="_blank"
              text
            >
                <span style="font-size: 1.2rem !important;">{{ item.title }}</span>
            </v-btn>
            <v-col
                class="text-center"
                cols="12"
            >
                {{ new Date().getFullYear() }} — <strong>DX-Sign</strong>
            </v-col>
        </v-row>
    </v-footer>
</template>

<script>
  export default {
    data () {
      return {
        items: [
          { title: '利用規約', link: '/documents/terms' },
          { title: '特定商取引に基づく表記', link: '/documents/law' },
          { title: '個人情報保護方針', link: 'https://www.valtec-sign.co.jp/privacypolicy/' },
          { title: '運営会社', link: 'https://www.valtec-sign.co.jp/' },
          { title: 'お問い合わせ', link: '/documents/contact' },
          { title: 'ヘルプ', link: '/documents/help' },
        ],
      };
    },
  };
</script>
<style scoped>
.v-btn, .v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
}
</style>